<template>
  <el-card style="height:130px;" :shadow="disabled?'never':'hover'" class="mt-10" v-bind:class="{ 'o-070':disabled, 'hand':!disabled }" @click.native="showReport(code)" :disabled="disabled">
    <i class="mdi mdi-file-find fs-50 mr-10 o-070" style="float:left;height:100%"></i>
    <div class="mt-10">
      <span class="">{{title}}</span><br>
      <span class="fs-14 secondary-text">{{description}}</span>
    </div>
  </el-card>
</template>
<script>
//import Section


export default {
  name : "reportTile",
  props: {
    code : {type : String},
    disabled : {type : Boolean, default : false},
    title : {type : String},
    description : {type : String}
	},
  data() {
    return {

    };
  },
  components : {

  },
  computed : {

  },
  methods : {
    showReport(reportCode){
      if(!this.disabled){
        var index = '/reports/' + reportCode
  			this.$router.push(index)
  			this.$emit('push-page', {page:index})
      }else{
        this.$message.warning("Ce rapport est en cours de développement.");
      }

    }
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

.hand {
  cursor:pointer;
}

</style>
